import { z } from 'zod';
import { ObjectValues } from 'common/tsHelpers.ts';

export const PROVISIONING_STATUS_LABEL = {
  PROCESSING_IN_PROGRESS: 'Processing in progress',
  PROCESSING_SUCCEED: 'Processing success',
  PROCESSING_FAILED: 'Processing fail',
  DATA_EXTRACTION_PENDING: 'Data extraction pending',
  DATA_EXTRACTION_IN_PROGRESS: 'Data extraction in progress',
  DATA_EXTRACTION_FAILED: 'Data extraction failed',
} as const;

export const PROVISIONING_STATUS = {
  PROCESSING_IN_PROGRESS: 0,
  PROCESSING_SUCCEED: 1,
  PROCESSING_FAILED: 2,
  DATA_EXTRACTION_PENDING: 3,
  DATA_EXTRACTION_IN_PROGRESS: 4,
  DATA_EXTRACTION_FAILED: 5,
} as const;

export const PROVISIONING_STATUS_TO_STATUS_LABEL_MAP = {
  [PROVISIONING_STATUS.PROCESSING_IN_PROGRESS]: PROVISIONING_STATUS_LABEL.PROCESSING_IN_PROGRESS,
  [PROVISIONING_STATUS.PROCESSING_SUCCEED]: PROVISIONING_STATUS_LABEL.PROCESSING_SUCCEED,
  [PROVISIONING_STATUS.PROCESSING_FAILED]: PROVISIONING_STATUS_LABEL.PROCESSING_FAILED,
  [PROVISIONING_STATUS.DATA_EXTRACTION_PENDING]: PROVISIONING_STATUS_LABEL.DATA_EXTRACTION_PENDING,
  [PROVISIONING_STATUS.DATA_EXTRACTION_IN_PROGRESS]:
    PROVISIONING_STATUS_LABEL.DATA_EXTRACTION_IN_PROGRESS,
  [PROVISIONING_STATUS.DATA_EXTRACTION_FAILED]: PROVISIONING_STATUS_LABEL.DATA_EXTRACTION_FAILED,
};

export const provisioningStatusFilterSchema = z.union([
  z.literal(PROVISIONING_STATUS.DATA_EXTRACTION_FAILED),
  z.literal(PROVISIONING_STATUS.DATA_EXTRACTION_IN_PROGRESS),
  z.literal(PROVISIONING_STATUS.DATA_EXTRACTION_PENDING),
  z.literal(PROVISIONING_STATUS.PROCESSING_FAILED),
  z.literal(PROVISIONING_STATUS.PROCESSING_IN_PROGRESS),
  z.literal(PROVISIONING_STATUS.PROCESSING_SUCCEED),
  z.literal(''),
]);

export type ProvisioningStatusFilter = z.infer<typeof provisioningStatusFilterSchema>;

export type ProvisioningStatus = ObjectValues<typeof PROVISIONING_STATUS>;

export type ProvisioningStatusLabel = ObjectValues<typeof PROVISIONING_STATUS_LABEL>;

export type SimStatusCount = {
  inProgress: number;
  succeed: number;
  failed: number;
};

export const parseProvisoningStatusFilter = (status: string | null): ProvisioningStatusFilter => {
  if (!status) {
    return '';
  }

  const statusParams = Number.parseInt(status);

  try {
    const parsedStatus = provisioningStatusFilterSchema.parse(statusParams);
    return parsedStatus;
  } catch {
    return '';
  }
};
